import { template as template_c2a92c54e2a54c5bb5250947c670c14c } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import { task } from 'ember-concurrency';
import { TrackedArray } from 'tracked-built-ins';
import { PAGE_SIZE } from 'eflex/constants/pagination';
import JobStatuses from 'eflex/constants/kinetic-job-statuses';
import { not } from 'ember-truth-helpers';
import { t } from 'ember-intl';
import { fn } from '@ember/helper';
import EmberGrid from 'eflex/components/ember-grid';
import { on } from '@ember/modifier';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { join, sortBy } from '@eflexsystems/ember-composable-helpers';
import { isEmpty } from '@ember/utils';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
export default class KineticWorkQueue extends Component {
    @service
    store;
    @service
    notifier;
    @service
    eventBus;
    @tracked
    assemblyOps = new TrackedArray();
    onDidInsert = task(waitFor(async ()=>{
        try {
            this.assemblyOps = await this._getData.perform();
            this.eventBus.trigger('resetPagination');
        } catch (e) {
            console.error(e);
            this.notifier.sendError('logs.searchFailed');
        }
    }));
    fetch = task(waitFor(async (params, pagination)=>{
        const assemblyOps = await this._getData.perform({
            ...params,
            ...pagination
        });
        this.assemblyOps.push(...assemblyOps);
    }));
    _getData = task(waitFor(async (params = {})=>{
        params.jobStatus = JobStatuses.released;
        return new TrackedArray(await this.store.query('kinetic-assembly-operation', {
            skip: 0,
            take: PAGE_SIZE,
            ...params
        }));
    }));
    onOperationSelected = (assemblyOperation)=>{
        if (assemblyOperation.stationNotAllowed(this.args.station)) {
            return;
        }
        this.args.onOperationSelected(assemblyOperation);
    };
    operationClickable = (operation)=>{
        if (isEmpty(this.args.onOperationSelected)) {
            return false;
        }
        return !(!operation.stationIsAllowed(this.args.station) || !operation.hasTasks);
    };
    static{
        template_c2a92c54e2a54c5bb5250947c670c14c(`
    <div {{didInsert this.onDidInsert.perform}}></div>
    {{#if (not (isEmpty this.assemblyOps))}}
      <EmberGrid
        class="jobs-grid"
        @data={{this.assemblyOps}}
        @fetch={{this.fetch.perform}}
        ...attributes
      >
        <thead>
          <tr>
            <th></th>
            <th>
              {{t "quantity"}}
            </th>
            <th>
              {{t "job"}}
            </th>
            <th>
              {{t "kinetic.assembly"}}
            </th>
            <th>
              {{t "kinetic.operation"}}
            </th>
            <th>
              {{t "kinetic.part"}}
            </th>
            <th>
              {{t "kinetic.revision"}}
            </th>
          </tr>
        </thead>
        <tbody>
          {{#each (sortBy "job.jobNumber" "assembly.assemblySequence" "sequence" this.assemblyOps) as |operation|}}
            <tr
              class="{{if (this.operationClickable operation) 'ember-grid-action-row'}} operation-row"
              {{on "click" (fn this.onOperationSelected operation)}}
            >
              <td class="app-operation-icon d-flex align-items-center flex-column">
                {{#if (not (isEmpty (operation.warnings @station))) }}
                  <div class="icon-message help" title={{join ", " (operation.warnings @station)}}>
                    <FaIcon @icon="triangle-exclamation" @prefix="fas" class="fa"/>
                  </div>
                {{/if}}
              </td>
              <td class="app-operation-quantity">
                {{operation.quantityCount}}
              </td>
              <td class="app-operation-job">
                {{operation.job.jobNumber}}
              </td>
              <td class="app-operation-assembly">
                {{operation.assembly.assemblySequence}}
              </td>
              <td class="app-operation-name">
                {{operation.name}}
              </td>
              <td class="app-part-name">
                {{operation.part.name}}
              </td>
              <td class="app-part-rev-name {{if operation.partRev.isOtf 'fst-italic otf-part-rev'}}">
                {{operation.partRev.name}}
              </td>
            </tr>
          {{/each}}
        </tbody>
      </EmberGrid>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
